import Component from 'ShopUi/models/component';
import CookieUtils from 'PyzShopUi/scripts/utils/cookieUtils';

const DECLINE_BUTTON_ID = 'cookie-notice-decline';
const ACCEPT_BUTTON_ID = 'cookie-notice-accept';
export const CONSENT_CHANGED_EVENT_NAME = 'louis_consent-changed';
export const ACCEPTANCE_COOKIE_NAME = 'cookie-notice-accepted';

const ACCEPTANCE_COOKIE_ACCEPTED_VALUE = '1';
const ACCEPTANCE_COOKIE_DENIED_VALUE = '0';
const ACCEPTANCE_COOKIE_DEFAULT_EXPIRATION_DAYS = 30;

function triggerConsentChangedEvent(): void {
    window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT_NAME));
}

export function handleAcceptAll() {
    setCookieAcceptedValue(true);

    triggerConsentChangedEvent();
}

export function etrackerConsentHandleAccept() {
    setCookieAcceptedValue(true);
    triggerConsentChangedEvent();
}

export function etrackerConsentHandleDeny() {
    setCookieAcceptedValue(false);
    triggerConsentChangedEvent();
}

export const isCookieNoticeAccepted = () => {
    const cookieNoticeValue = CookieUtils.getCookieValue(
        ACCEPTANCE_COOKIE_NAME
    );

    return cookieNoticeValue === ACCEPTANCE_COOKIE_ACCEPTED_VALUE;
};

export const setCookieAcceptedValue = (accepted: boolean) => {
    const value = accepted
        ? ACCEPTANCE_COOKIE_ACCEPTED_VALUE
        : ACCEPTANCE_COOKIE_DENIED_VALUE;

    CookieUtils.setCookie(
        ACCEPTANCE_COOKIE_NAME,
        value,
        ACCEPTANCE_COOKIE_DEFAULT_EXPIRATION_DAYS,
        'Lax'
    );
};

export default class CookieNotice extends Component {
    protected readyCallback(): void {
    }

    acceptCookies() {
        handleAcceptAll();
        this.remove();
    }

    declineCookies() {
        setCookieAcceptedValue(false);
        triggerConsentChangedEvent();
        this.remove();
    }

    init() {
        const acceptButton = document.getElementById(ACCEPT_BUTTON_ID);
        const declineButton = document.getElementById(DECLINE_BUTTON_ID);

        // the .bind(this) makes 'this' refer to the class this within the callback
        acceptButton.addEventListener('click', this.acceptCookies.bind(this));
        declineButton.addEventListener('click', this.declineCookies.bind(this));
    }
}
